<template>
    <div>
        <progress-bar v-if="! isLoading" :no-upload-step="noUploadStep" :hasLastStep="true"></progress-bar>

        <Form
            v-bind:controls="controls"
            v-bind:title="title"
            v-bind:intro="intro"
            v-bind:remarks="remarks"
            v-bind:action="action"
            v-bind:formid="formid"
            v-bind:csrf="csrf"
            v-on:submitSuccess="doRedirect"

            v-if="controls"
        >
            <template v-slot:buttons>
                <div class="d-flex">
                    <back-button v-if="!['documents'].includes($route.name)" :noUploadStep="noUploadStep"></back-button>
                    <button class="button form__button ml-auto" type="submit">
                        <T>afronden</T> <i class="icon-chevron-right button__icon button__icon--right"></i>
                    </button>
                    </div>
            </template>
        </Form>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Form from '../modules/form/components/Form';

    export default {
        name: 'DocumentProcess',
        components: {
            Form,
        },
        data: function(){
            return {
                isLoading: true,
                controls: null,
                title: null,
                action: null,
                intro: null,
                remarks: 'Test opmerking kandidaat',
                formid: null,
                csrf: null,
                noUploadStep: null,
            };
        },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            activeLocale() {
                this.getForm();
            },
        },
        methods: {
            doRedirect(data) {
                if(! data.documentsRemaining) {
                    this.$router.push({ name:'thank-you'});
                }else {
                    this.$router.push({ name:'documents'});
                }
            },
            getForm() {
                this.$store.commit('setLoading',true);

                // get the current document
                this.$Api.get('document-form/' + this.$route.params.document)
                        .then((response) => {
                            this.formid = response.data.formid;
                            this.controls = response.data.controls;
                            this.action = response.data.action;
                            this.title = response.data.title;
                            this.intro = response.data.intro;
                            this.remarks = response.data.remarks;
                            this.noUploadStep = !response.data.copyRequired;
                            this.isLoading = false;
                            this.csrf = response.data.csrf
                        });
            },

        },
        created: function() {
            this.getForm();
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/DocumentProcess.vue